// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mask_video_wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mask_video_inner_div {
  width: 1081px;
  height: 85vh;
  position: relative;
  margin: 100px 0 140px 0;
}

.mask_video_section {
  width: 1081px;
  height: 85vh;
  position: absolute;
  z-index: 1;
}

.mask_video_section > video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.mask_cards_div {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mask_card {
  width: 25%;
  height: 100%;
  border-left: 12px solid #151615; 
  border-right: 12px solid #151615;
  display: flex;
  flex-direction: column;
}

.mask_card_major {
  width: 100%;
  height: calc(100% - 88px);
}

.mask_card_minor {
  width: 100%;
  height: 88px;
  background-color: #151615;
}

@media screen and (max-width: 1200px) {
  .mask_video_wrapper {
    width: 100%;
    padding: 0 50px;
  }

  .mask_video_inner_div {
    width: 100%;
    height: 80vh;
    margin: 100px 0 100px 0;
  }

  .mask_video_section {
    width: 100%;
    height: 80vh;
  }

  .mask_cards_div {
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .mask_card {
    width: 25%;
    border-left: 10px solid #151615;
    border-right: 10px solid #151615;
    flex-direction: column;
  }

  .mask_card_major {
    width: 100%;
    height: calc(100% - 70px);
  }

  .mask_card_minor {
    width: 100%;
    height: 70px;
  }
}

@media screen and (max-width: 1024px) {
  .mask_video_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .mask_video_inner_div {
    width: 100%;
    height: 80vh;
    margin: 100px 0 100px 0;
  }

  .mask_video_section {
    width: 100%;
    height: 80vh;
  }

  .mask_cards_div {
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .mask_card {
    width: 25%;
    border-left: 10px solid #151615;
    border-right: 10px solid #151615;
    flex-direction: column;
  }

  .mask_card_major {
    width: 100%;
    height: calc(100% - 50px);
  }

  .mask_card_minor {
    width: 100%;
    height: 50px;
  }
}

@media screen and (max-width: 800px) {
  .mask_video_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .mask_video_inner_div {
    width: 100%;
    height: 60vh;
    margin: 70px 0 70px 0;
  }

  .mask_video_section {
    width: 100%;
    height: 60vh;
    overflow: hidden;
  }

  .mask_cards_div {
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .mask_card {
    width: 25%;
    border-left: 8px solid #151615;
    border-right: 8px solid #151615;
    flex-direction: column;
  }

  .mask_card_major {
    width: 100%;
    height: calc(100% - 40px);
  }

  .mask_card_minor {
    width: 100%;
    height: 40px;
  }
}

@media screen and (max-width: 600px) {
  .mask_video_wrapper {
    width: 100%;
    padding: 0 20px;
  }

  .mask_video_inner_div {
    width: 100%;
    height: 350px;
    margin: 70px 0 70px 0;
  }

  .mask_video_section {
    width: 100%;
    height: 350px;
    overflow: hidden;
  }

  .mask_cards_div {
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .mask_card {
    width: 25%;
    border-left: 4px solid #151615;
    border-right: 4px solid #151615;
    flex-direction: column;
  }

  .mask_card_major {
    width: 100%;
    height: calc(100% - 40px);
  }

  .mask_card_minor {
    width: 100%;
    height: 40px;
  }
}

@media screen and (max-width: 450px) {
  .mask_video_wrapper {
    width: 100%;
    padding: 0 0px;
  }

  .mask_video_inner_div {
    width: 100%;
    height: 400px;
    margin: 30px 0 50px 0;
  }

  .mask_video_section {
    width: 100%;
    height: 400px;
    overflow: hidden;
  }

  .mask_video_section > video {
    object-fit: cover;
  }

  .mask_cards_div {
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .mask_card {
    width: 25%;
    border-left: 3px solid #151615;
    border-right: 3px solid #151615;
    flex-direction: column;
  }

  .mask_card_major {
    width: 100%;
    height: calc(100% - 40px) !important;
    height: -webkit-calc(100% - 40px) !important;
  }

  .mask_card_minor {
    width: 100%;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/homePage/maskVideo/maskVideo.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,+BAA+B;IAC/B,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,oCAAoC;IACpC,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".mask_video_wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mask_video_inner_div {\n  width: 1081px;\n  height: 85vh;\n  position: relative;\n  margin: 100px 0 140px 0;\n}\n\n.mask_video_section {\n  width: 1081px;\n  height: 85vh;\n  position: absolute;\n  z-index: 1;\n}\n\n.mask_video_section > video {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n.mask_cards_div {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mask_card {\n  width: 25%;\n  height: 100%;\n  border-left: 12px solid #151615; \n  border-right: 12px solid #151615;\n  display: flex;\n  flex-direction: column;\n}\n\n.mask_card_major {\n  width: 100%;\n  height: calc(100% - 88px);\n}\n\n.mask_card_minor {\n  width: 100%;\n  height: 88px;\n  background-color: #151615;\n}\n\n@media screen and (max-width: 1200px) {\n  .mask_video_wrapper {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .mask_video_inner_div {\n    width: 100%;\n    height: 80vh;\n    margin: 100px 0 100px 0;\n  }\n\n  .mask_video_section {\n    width: 100%;\n    height: 80vh;\n  }\n\n  .mask_cards_div {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n  }\n\n  .mask_card {\n    width: 25%;\n    border-left: 10px solid #151615;\n    border-right: 10px solid #151615;\n    flex-direction: column;\n  }\n\n  .mask_card_major {\n    width: 100%;\n    height: calc(100% - 70px);\n  }\n\n  .mask_card_minor {\n    width: 100%;\n    height: 70px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .mask_video_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .mask_video_inner_div {\n    width: 100%;\n    height: 80vh;\n    margin: 100px 0 100px 0;\n  }\n\n  .mask_video_section {\n    width: 100%;\n    height: 80vh;\n  }\n\n  .mask_cards_div {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n  }\n\n  .mask_card {\n    width: 25%;\n    border-left: 10px solid #151615;\n    border-right: 10px solid #151615;\n    flex-direction: column;\n  }\n\n  .mask_card_major {\n    width: 100%;\n    height: calc(100% - 50px);\n  }\n\n  .mask_card_minor {\n    width: 100%;\n    height: 50px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .mask_video_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .mask_video_inner_div {\n    width: 100%;\n    height: 60vh;\n    margin: 70px 0 70px 0;\n  }\n\n  .mask_video_section {\n    width: 100%;\n    height: 60vh;\n    overflow: hidden;\n  }\n\n  .mask_cards_div {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n  }\n\n  .mask_card {\n    width: 25%;\n    border-left: 8px solid #151615;\n    border-right: 8px solid #151615;\n    flex-direction: column;\n  }\n\n  .mask_card_major {\n    width: 100%;\n    height: calc(100% - 40px);\n  }\n\n  .mask_card_minor {\n    width: 100%;\n    height: 40px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .mask_video_wrapper {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .mask_video_inner_div {\n    width: 100%;\n    height: 350px;\n    margin: 70px 0 70px 0;\n  }\n\n  .mask_video_section {\n    width: 100%;\n    height: 350px;\n    overflow: hidden;\n  }\n\n  .mask_cards_div {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n  }\n\n  .mask_card {\n    width: 25%;\n    border-left: 4px solid #151615;\n    border-right: 4px solid #151615;\n    flex-direction: column;\n  }\n\n  .mask_card_major {\n    width: 100%;\n    height: calc(100% - 40px);\n  }\n\n  .mask_card_minor {\n    width: 100%;\n    height: 40px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .mask_video_wrapper {\n    width: 100%;\n    padding: 0 0px;\n  }\n\n  .mask_video_inner_div {\n    width: 100%;\n    height: 400px;\n    margin: 30px 0 50px 0;\n  }\n\n  .mask_video_section {\n    width: 100%;\n    height: 400px;\n    overflow: hidden;\n  }\n\n  .mask_video_section > video {\n    object-fit: cover;\n  }\n\n  .mask_cards_div {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n  }\n\n  .mask_card {\n    width: 25%;\n    border-left: 3px solid #151615;\n    border-right: 3px solid #151615;\n    flex-direction: column;\n  }\n\n  .mask_card_major {\n    width: 100%;\n    height: calc(100% - 40px) !important;\n    height: -webkit-calc(100% - 40px) !important;\n  }\n\n  .mask_card_minor {\n    width: 100%;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
